import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const FilePreviewScreen = lazy(() => import('~/features/item-setup/pages/file-preview-screen'));

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/file-preview')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <FilePreviewScreen />
    </Suspense>
  ),
});
